import Vue from 'vue'

/**
 * v-hover-editor 指令
 * 功能：鼠标悬停时在元素右上角显示编辑图标
 * 使用方式：<div v-hover-editor>内容</div>
 */
export default {
  bind(el, binding, vnode) {
    // 保存原始定位和光标样式
    const originalPosition = window.getComputedStyle(el).position
    const originalCursor = el.style.cursor
    
    // 如果元素没有定位，设置为relative以便图标绝对定位
    if (originalPosition === 'static') {
      el.style.position = 'relative'
    }

    // 创建编辑图标的函数
    const createEditorIcon = () => {
      // 检查是否已存在图标，避免重复创建
      if (el.querySelector('.hover-editor-icon')) {
        return
      }

      // 创建图标容器
      const iconWrapper = document.createElement('div')
      iconWrapper.className = 'hover-editor-icon'
      iconWrapper.style.cssText = `
        position: absolute;
        top: 4px;
        right: 4px;
        z-index: 999;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 24px;
        height: 24px;
        border-radius: 4px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        transition: all 0.3s ease;
      `

      // 创建SVG图标
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
      svg.setAttribute('class', 'svg-icon editor')
      svg.setAttribute('aria-hidden', 'true')
      svg.style.cssText = `
        width: 16px;
        height: 16px;
        fill: currentColor;
        color: #409EFF;
      `

      const use = document.createElementNS('http://www.w3.org/2000/svg', 'use')
      use.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#icon-editor')

      svg.appendChild(use)
      iconWrapper.appendChild(svg)

      // 点击图标时触发自定义事件或回调
      iconWrapper.addEventListener('click', (e) => {
        // 移除 e.stopPropagation()，允许事件冒泡到父元素
        // 如果指令绑定了值（函数），则执行
        if (binding.value && typeof binding.value === 'function') {
          binding.value(el)
        }
        // 触发自定义事件
        el.dispatchEvent(new CustomEvent('editor-click', { detail: { element: el } }))
      })

      el.appendChild(iconWrapper)
    }

    // 移除编辑图标的函数
    const removeEditorIcon = () => {
      const icon = el.querySelector('.hover-editor-icon')
      if (icon) {
        icon.remove()
      }
    }

    // 鼠标进入事件
    const handleMouseEnter = () => {
      el.style.cursor = 'pointer'
      createEditorIcon()
    }

    // 鼠标离开事件
    const handleMouseLeave = () => {
      el.style.cursor = originalCursor
      removeEditorIcon()
    }

    // 绑定事件监听器
    el.addEventListener('mouseenter', handleMouseEnter)
    el.addEventListener('mouseleave', handleMouseLeave)

    // 在元素上保存事件处理函数，以便在unbind时移除
    el._hoverEditorHandlers = {
      mouseenter: handleMouseEnter,
      mouseleave: handleMouseLeave,
      originalPosition,
      originalCursor
    }
  },

  unbind(el) {
    // 移除事件监听器
    if (el._hoverEditorHandlers) {
      el.removeEventListener('mouseenter', el._hoverEditorHandlers.mouseenter)
      el.removeEventListener('mouseleave', el._hoverEditorHandlers.mouseleave)
      
      // 恢复原始样式
      if (el._hoverEditorHandlers.originalPosition === 'static') {
        el.style.position = ''
      }
      el.style.cursor = el._hoverEditorHandlers.originalCursor

      // 移除可能残留的图标
      const icon = el.querySelector('.hover-editor-icon')
      if (icon) {
        icon.remove()
      }

      // 清理保存的引用
      delete el._hoverEditorHandlers
    }
  }
}



// WEBPACK FOOTER //
// ./src/directives/hover-editor.js